import React from 'react';
import { Link } from 'react-router-dom';

import NavList from 'Site/Ui/NavList';
import MobileNav from 'Site/Ui/MobileNav';

class Header extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { location } = this.props;

    return (
      <header className="Header">
        <grid>
          <box className="xs-5 sm-4 md-3 lg-3">
            <Link to="/">
              <img src="assets/logo-black.svg" className="Main-Logo" />
            </Link>
          </box>
          <box className="_md-hide lg-8 lg-offset-1 xl-7 xl-offset-2">
            <NavList location={location} />
          </box>
          <box className="xs-7 sm-8 md-9 lg_-hide">
            <MobileNav location={location} />
          </box>
        </grid>
      </header>
    );
  }
};

export default Header;



// WEBPACK FOOTER //
// ./client/Site/Ui/Header.jsx